// !!!WARNING!!!
// Only use this in a React component that has parent ErrorBoundary to catch the error
export default function propagate403Error(error: keyable) {
  if (error && error.status === 403) {
    throw error;
  }
}
